/**
 * @generated SignedSource<<18f4794599986ba836f4744dea4812a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PersonNote_viewer$data = {
  readonly id: number;
  readonly user_accounts: ReadonlyArray<{
    readonly id: number;
    readonly user: {
      readonly email: string;
      readonly first_name: string | null | undefined;
      readonly id: number;
      readonly last_name: string | null | undefined;
    };
  }>;
  readonly " $fragmentType": "PersonNote_viewer";
};
export type PersonNote_viewer$key = {
  readonly " $data"?: PersonNote_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PersonNote_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PersonNote_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "user_accounts",
      "kind": "LinkedField",
      "name": "user_accounts",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "users",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "first_name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "last_name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "users",
  "abstractKey": null
};
})();

(node as any).hash = "d6769a6af7ce0fe13aa24f5383390714";

export default node;
